import { render } from "./WidgetAnwendungsFavoriten.vue?vue&type=template&id=547ffcb3&ts=true"
import script from "./WidgetAnwendungsFavoriten.vue?vue&type=script&lang=ts"
export * from "./WidgetAnwendungsFavoriten.vue?vue&type=script&lang=ts"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__